import { useState, useEffect } from 'react';
import { savecontact, editcontact } from '../components/DbServices';
import Swal from 'sweetalert2';

export default function AddContactModal({
  userId,
  contact,
  onClose,
  onSaved
}) {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (contact) {
      setName(contact.name);
      setNumber(contact.number);
    }
  }, [contact]);

  const submit = async () => {
    setError('');
    if (!name || !number) {
      setError('Name and Number are required');
      return;
    }

    // Cleaning the number (removing spaces or +) to ensure it's just digits
    const cleanNumber = number.replace(/\D/g, '');
    if (cleanNumber.length < 10 || cleanNumber.length > 15) {
      setError('Enter a valid phone number (10-15 digits)');
      return;
    }

    setLoading(true);

    const payload = {
      user: userId,
      name,
      number: cleanNumber,
      status: 1
    };

    try {
      let res;
      if (contact) {
        payload.id = contact.id;
        res = await editcontact(payload);
      } else {
        res = await savecontact(payload);
      }

      if (res?.status === 200 || res?.success) {
        onSaved();
        onClose();
      } else {
        setError('Failed to save contact. Please try again.');
      }
    } catch (err) {
      setError('Connection error. Please check your internet.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="custom-modal-backdrop" style={{ alignItems: 'center' }}>
      <div className="custom-modal border-0 shadow-lg" style={{ maxWidth: '450px', width: '95%', borderRadius: '20px', overflow: 'hidden', padding: '0' }}>
        
        {/* Header with your Gradient Class */}
        <div className="bg-primary p-4 text-white text-center">
          <h5 className="fw-bold mb-0">
            {contact ? '✏️ Edit Contact' : '👤 New Contact'}
          </h5>
          <p className="mb-0 x-small text-white-50">
            {contact ? 'Update existing details' : 'Add someone to your broadcast list'}
          </p>
        </div>

        <div className="p-4 bg-white">
          {error && (
            <div className="Swal Swal-danger py-2 border-0 shadow-sm mb-4 small fw-bold">
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              {error}
            </div>
          )}

          <div className="mb-3">
            <label className="small fw-bold text-muted mb-1 text-uppercase">Full Name</label>
            <input
              className="form-control form-control-lg border-2 shadow-none"
              style={{ borderRadius: '12px', fontSize: '14px' }}
              placeholder="e.g. John Doe"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="small fw-bold text-muted mb-1 text-uppercase">WhatsApp Number</label>
            <div className="input-group">
               <span className="input-group-text bg-light border-2 border-end-0" style={{ borderRadius: '12px 0 0 12px' }}>
                 <i className="bi bi-whatsapp text-success"></i>
               </span>
               <input
                className="form-control form-control-lg border-2 border-start-0 shadow-none"
                style={{ borderRadius: '0 12px 12px 0', fontSize: '14px' }}
                placeholder="919876543210"
                value={number}
                onChange={e => setNumber(e.target.value)}
              />
            </div>
            <div className="form-text x-small mt-2">
              Include country code (e.g. <b>91</b> for India) without '+' or spaces.
            </div>
          </div>

          <div className="d-flex flex-column gap-2">
            <button
              className="btn btn-primary btn-lg w-100 fw-bold py-2 shadow-sm"
              style={{ borderRadius: '12px' }}
              onClick={submit}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </>
              ) : (
                'Save Contact'
              )}
            </button>

            <button
              className="btn btn-light btn-sm w-100 py-2 text-muted"
              style={{ borderRadius: '12px' }}
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}